import React from 'react'
import cimg1 from "../images/cimg1.jpg"

function Commonheader(props) {
    return (
        <>
            <div class="inner_banner col-lg-12 col-xs-12">
                <img src={cimg1} class="img-responsive" alt="Bakra Mandi" />
            </div>

        
        </>
    )
}

export default Commonheader